// 能够使用课堂考核功能的学校列表
export const examSchoolList = ["49533847984934912","457463292223295488"]
// 能够使用单题考核功能的学校列表
export const examSingleSchoolList = ["49533847984934912"]